import { CONTROLS } from '../constants'

export default function getControl (id: string) {
  return CONTROLS[id]
}
